import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  const fadeIn = useFadeIn();
  return <section className="py-10 md:py-20 px-4 bg-black text-white border-t-8 border-yellow-400" data-id="element-80">
      <div className="max-w-3xl mx-auto text-center" data-id="element-81">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-82">
          <ShieldCheckIcon className="w-16 h-16 md:w-24 md:h-24 text-yellow-400 mx-auto mb-4 md:mb-6" data-id="element-83" />

          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 md:mb-8 uppercase tracking-wide" data-id="element-84">
            🔒 GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <div className="text-lg md:text-2xl text-gray-300 space-y-3 md:space-y-4 mb-8 md:mb-12 max-w-2xl mx-auto font-medium" data-id="element-85">
            <p data-id="element-86">
              Descargás el pack. Imprimís algunas citas o las leés desde el
              celular.
            </p>
            <p data-id="element-87">
              Si en 7 días sentís que no te ayudó a conectar más con tu familia:
              devolución del 100% sin formularios, sin drama.
            </p>
            <p className="text-yellow-400 font-bold" data-id="element-88">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-800 p-6 md:p-8 rounded-2xl mb-8 md:mb-12 shadow-2xl" data-id="element-89">
            <h3 className="text-2xl md:text-3xl font-black text-blue-500 mb-3 md:mb-4" data-id="element-90">
              💙 La infancia pasa volando
            </h3>
            <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-91">
              No esperes a las vacaciones para crear recuerdos.
            </p>
            <p className="text-xl md:text-2xl font-bold text-yellow-400 mb-3 md:mb-4" data-id="element-92">
              La magia pasa en los días comunes. 💙
            </p>
            <p className="text-base md:text-lg text-gray-400 font-medium" data-id="element-93">
              Porque jugar con tus hijos no debería sentirse como una obligación
              más en tu agenda.
            </p>
          </div>

          <div className="max-w-md mx-auto" data-id="element-94">
            <CTAButton text="👉 QUIERO MI PACK DE CITAS AHORA" size="sm" data-id="element-95" />
          </div>
        </div>
      </div>
    </section>;
}